import React from "react";
import moment from "moment";

import "./JobSwmsFormStyle.css";

// Define SVG icons for statuses
const APPROVED_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z" />
  </svg>
);

const REJECTED_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM231 231C240.4 221.6 255.6 221.6 264.9 231L319.9 286L374.9 231C384.3 221.6 399.5 221.6 408.8 231C418.1 240.4 418.2 255.6 408.8 264.9L353.8 319.9L408.8 374.9C418.2 384.3 418.2 399.5 408.8 408.8C399.4 418.1 384.2 418.2 374.9 408.8L319.9 353.8L264.9 408.8C255.5 418.2 240.3 418.2 231 408.8C221.7 399.4 221.6 384.2 231 374.9L286 319.9L231 264.9C221.6 255.5 221.6 240.3 231 231z" />
  </svg>
);

const IN_PROGRESS_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M272 112C272 85.5 293.5 64 320 64C346.5 64 368 85.5 368 112C368 138.5 346.5 160 320 160C293.5 160 272 138.5 272 112zM272 528C272 501.5 293.5 480 320 480C346.5 480 368 501.5 368 528C368 554.5 346.5 576 320 576C293.5 576 272 554.5 272 528zM112 272C138.5 272 160 293.5 160 320C160 346.5 138.5 368 112 368C85.5 368 64 346.5 64 320C64 293.5 85.5 272 112 272zM480 320C480 293.5 501.5 272 528 272C554.5 272 576 293.5 576 320C576 346.5 554.5 368 528 368C501.5 368 480 346.5 480 320zM139 433.1C157.8 414.3 188.1 414.3 206.9 433.1C225.7 451.9 225.7 482.2 206.9 501C188.1 519.8 157.8 519.8 139 501C120.2 482.2 120.2 451.9 139 433.1zM139 139C157.8 120.2 188.1 120.2 206.9 139C225.7 157.8 225.7 188.1 206.9 206.9C188.1 225.7 157.8 225.7 139 206.9C120.2 188.1 120.2 157.8 139 139zM501 433.1C519.8 451.9 519.8 482.2 501 501C482.2 519.8 451.9 519.8 433.1 501C414.3 482.2 414.3 451.9 433.1 433.1C451.9 414.3 482.2 414.3 501 433.1z" />
  </svg>
);

const PENDING_APPROVAL_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z" />
  </svg>
);

const NO_RESPONSE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320z" />
  </svg>
);

const RESEND_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="12" height="12">
    <path fill="currentColor" d="M320 128C263.2 128 212.1 152.7 176.9 192L224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256L96 256C78.3 256 64 241.7 64 224L64 96C64 78.3 78.3 64 96 64C113.7 64 128 78.3 128 96L128 150.7C174.9 97.6 243.5 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C233 576 156.1 532.6 109.9 466.3C99.8 451.8 103.3 431.9 117.8 421.7C132.3 411.5 152.2 415.1 162.4 429.6C197.2 479.4 254.8 511.9 320 511.9C426 511.9 512 425.9 512 319.9C512 213.9 426 128 320 128z" />
  </svg>
);

const REJECTION_NOTES_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="10" height="10">
    <path fill="currentColor" d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z" />
  </svg>
);

// Edit (pencil) icon for amendment note
const EDIT_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="16" height="16" style={{ color: '#f59e42', display: 'block' }}>
    <path fill="currentColor" d="M535.6 85.7C513.7 63.8 478.3 63.8 456.4 85.7L432 110.1L529.9 208L554.3 183.6C576.2 161.7 576.2 126.3 554.3 104.4L535.6 85.7zM236.4 305.7C230.3 311.8 225.6 319.3 222.9 327.6L193.3 416.4C190.4 425 192.7 434.5 199.1 441C205.5 447.5 215 449.7 223.7 446.8L312.5 417.2C320.7 414.5 328.2 409.8 334.4 403.7L496 241.9L398.1 144L236.4 305.7zM160 128C107 128 64 171 64 224L64 480C64 533 107 576 160 576L416 576C469 576 512 533 512 480L512 384C512 366.3 497.7 352 480 352C462.3 352 448 366.3 448 384L448 480C448 497.7 433.7 512 416 512L160 512C142.3 512 128 497.7 128 480L128 224C128 206.3 142.3 192 160 192L256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128L160 128z" />
  </svg>
);

// Submission (rocket) icon for submission header
const SUBMISSION_ICON = (color = '#6366f1') => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="16" height="16" style={{ color, display: 'block' }}>
    <path fill="currentColor" d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z" />
  </svg>
);

const STATUS_LABELS = {
  in_progress: "In Progress",
  superseded: "Superseded",
  approved: "Approved",
};

const REVIEWER_STATUS_LABELS = {
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
  pending: "Pending",
  no_response: "No Response",
};

const getVersionBadgeClass = (status) => {
  if (status === "in_progress") return "swms-version-badge swms-version-badge-current";
  if (status === "approved") return "swms-version-badge swms-version-badge-approved";
  return "swms-version-badge swms-version-badge-superseded";
};

const getVersionStatusPillClass = (status) => {
  if (status === "in_progress") return "swms-version-status-pill swms-version-status-in-progress";
  if (status === "approved") return "swms-version-status-pill swms-version-status-approved";
  return "swms-version-status-pill swms-version-status-superseded";
};

const getVersionStatusIcon = (status) => {
  if (status === "in_progress") return IN_PROGRESS_ICON;
  if (status === "approved") return APPROVED_ICON;
  if (status === "superseded") return REJECTED_ICON;
  return null;
};

const getReviewerBadgeClass = (status) => {
  if (status === "approved") return "swms-reviewer-badge swms-reviewer-badge-approved";
  if (status === "rejected" || status === "cancelled") return "swms-reviewer-badge swms-reviewer-badge-rejected";
  if (status === "pending") return "swms-reviewer-badge swms-reviewer-badge-pending";
  return "swms-reviewer-badge swms-reviewer-badge-no-response";
};

const getReviewerAvatarClass = (status) => {
  if (status === "approved") return "swms-reviewer-avatar swms-reviewer-avatar-approved";
  if (status === "rejected" || status === "cancelled") return "swms-reviewer-avatar swms-reviewer-avatar-rejected";
  if (status === "pending" || status === "pendingApproval") return "swms-reviewer-avatar swms-reviewer-avatar-pending";
  return "swms-reviewer-avatar swms-reviewer-avatar-no-response";
};

const getReviewerBadgeIcon = (status) => {
  if (status === "approved") return APPROVED_ICON;
  if (status === "rejected" || status === "cancelled") return REJECTED_ICON;
  if (status === "pending") return PENDING_APPROVAL_ICON;
  if (status === "pendingApproval") return PENDING_APPROVAL_ICON;
  if (status === "no_response") return NO_RESPONSE_ICON;
  return null;
};

const getVersionLabelNumber = (version, fallbackIndex) => {
  if (version && version.versionNumber !== undefined && version.versionNumber !== null) {
    return version.versionNumber;
  }

  if (version && version.version_number) {
    const numericVersion = `${version.version_number}`.replace(/^[^\d]*/, "");
    if (numericVersion) {
      return numericVersion;
    }
  }

  return fallbackIndex;
};

const getEditText = (version) => version.edit_text || version.edit_note || version.amendment_note;

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.split(" ");
  return parts.map((part) => part[0]).join("").toUpperCase();
};

const VersionHistorySection = ({ versions = [], loading, onResendReviewer }) => {
  if (!versions || versions.length === 0) {
    return (
      <div className="my-2" style={{ color: "#94a3b8", fontSize: "13px", textAlign: "center", padding: "16px 0" }}>
        No version history available.
      </div>
    );
  }

  return (
    <div className="my-2">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-12">
            <div className="swms-version-timeline">
              {versions.map((version, vIndex) => (
                <div key={vIndex} className="swms-version-entry">
                  {/* Version header row */}
                  <div className="swms-version-header-row">
                    <div className="swms-version-badge-col">
                      <span className={getVersionBadgeClass(version.status)}>
                        {version.version_number || `v${vIndex + 1}`}
                      </span>
                      {vIndex < versions.length - 1 && (
                        <div className="swms-version-timeline-line mx-auto" />
                      )}
                    </div>
                    <div className="swms-version-header-content">
                      <div className="swms-version-meta-row">
                        <span className="swms-version-number-label">
                          Version {getVersionLabelNumber(version, vIndex)}
                        </span>
                        {version.swms_id && (
                          <span className={`swms-version-id-tag${version.status === "in_progress" ? " swms-version-id-tag-in-progress" : ""}`}>
                            {version.swms_id}
                          </span>
                        )}
                        {version.created_at && (
                          <span className="swms-version-created-label">
                            Created {moment.utc(version.created_at).format("DD/MM/YYYY")}
                            {version.created_by ? ` by ${version.created_by}` : ""}
                          </span>
                        )}
                        <span className={getVersionStatusPillClass(version.status)} style={{ display: "inline-flex", alignItems: "center", marginLeft: "auto" }}>
                          {getVersionStatusIcon(version.status)}
                          {STATUS_LABELS[version.status] || version.status || ""}
                        </span>
                      </div>

                      {/* Edit note */}
                      {getEditText(version) && (
                        <div className="swms-amendment-note">
                          <div className="swms-amendment-note-icon" style={{ background: '#fef3c7' }}>
                            {EDIT_ICON}
                          </div>
                          <div>
                            <div className="swms-amendment-note-label">Edit</div>
                            <div className="swms-amendment-note-text">{getEditText(version)}</div>
                          </div>
                        </div>
                      )}

                      {/* Submissions */}
                      {version.submissions && version.submissions.length > 0 && (
                        <div>
                          {version.submissions.map((submission, sIndex) => (
                            <div key={sIndex} className="swms-submission-block">
                              {(() => {
                                const isSubmissionSuperseded = version.status === "superseded" || (submission && submission.is_cancelled === true);
                                return (
                                  <>
                              {/* Submission header */}
                              <div className="swms-submission-header">
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    color: isSubmissionSuperseded ? '#94A3B8' : '#6366f1',
                                  }}
                                >
                                  {SUBMISSION_ICON(isSubmissionSuperseded ? '#94A3B8' : '#6366f1')}
                                </span>
                                <span className={`swms-submission-label${isSubmissionSuperseded ? ' swms-submission-label-superseded' : ''}`}>
                                  Submission {version.submissions.length - sIndex}
                                </span>
                                {submission.sent_at && (
                                  <span className={`swms-submission-meta${isSubmissionSuperseded ? ' swms-submission-meta-superseded' : ''}`}>
                                    Sent {moment.utc(submission.sent_at).format("DD/MM/YYYY")}
                                    {submission.reviewer_count
                                      ? ` · ${submission.reviewer_count} reviewer${submission.reviewer_count !== 1 ? "s" : ""}`
                                      : ""}
                                  </span>
                                )}
                              </div>

                              {/* Reviewer rows */}
                              {submission.reviewers && submission.reviewers.length > 0 && (
                                <div>
                                  {submission.reviewers.map((reviewer, rIndex) => {
                                    const isSupersededPending = isSubmissionSuperseded && reviewer.status === "pending";
                                    const effectiveReviewerStatus = isSupersededPending ? "no_response" : reviewer.status;

                                    return (
                                    <div key={rIndex}>
                                      <div className="swms-reviewer-row">
                                        <div className={getReviewerAvatarClass(effectiveReviewerStatus)}>
                                          {getInitials(reviewer.name)}
                                        </div>
                                        <div className="swms-reviewer-info">
                                          <span className={`swms-reviewer-name${isSubmissionSuperseded ? " swms-reviewer-name-superseded" : ""}`}>
                                            {reviewer.name || ""}
                                          </span>
                                          {reviewer.position && (
                                            <span className="swms-reviewer-position">
                                              {" "}{reviewer.position}
                                            </span>
                                          )}
                                          {reviewer.responded_at && (
                                            <div className="swms-reviewer-responded">
                                              Responded {moment.utc(reviewer.responded_at).format("DD/MM/YYYY")}
                                            </div>
                                          )}
                                          {effectiveReviewerStatus === "cancelled" && (
                                            <div className="swms-reviewer-responded" style={{ color: "#cbd5e1" }}>
                                              Approval Cancelled
                                            </div>
                                          )}
                                          {effectiveReviewerStatus === "pending" && !reviewer.responded_at && (
                                            <div className="swms-reviewer-responded" style={{ color: "#94a3b8" }}>
                                              Link sent · awaiting response
                                            </div>
                                          )}
                                          {effectiveReviewerStatus === "no_response" && (
                                            <div className="swms-reviewer-responded" style={{ color: "#cbd5e1" }}>
                                              - No Response before changes
                                            </div>
                                          )}
                                        </div>
                                        <div className="swms-reviewer-actions">
                                          <span className={getReviewerBadgeClass(effectiveReviewerStatus)} style={{ display: "inline-flex", alignItems: "center" }}>
                                            {getReviewerBadgeIcon(effectiveReviewerStatus)}
                                            {REVIEWER_STATUS_LABELS[effectiveReviewerStatus] || effectiveReviewerStatus || ""}
                                          </span>
                                          {effectiveReviewerStatus === "pending" && (
                                            <button
                                              className="swms-auth-resend-btn"
                                              disabled={loading}
                                              onClick={() => onResendReviewer && onResendReviewer(reviewer)}
                                              type="button"
                                              style={{ marginLeft: "6px" }}
                                            >
                                              {RESEND_ICON}
                                              Resend
                                            </button>
                                          )}
                                        </div>
                                      </div>

                                      {/* Rejection notes */}
                                      {reviewer.status === "rejected" && reviewer.rejection_notes && (
                                        <div className="swms-reviewer-rejection-note">
                                          <span className="swms-reviewer-rejection-label">
                                            {REJECTION_NOTES_ICON}
                                            Rejection Notes
                                          </span>
                                          <div className="swms-reviewer-rejection-text">
                                            {reviewer.rejection_notes}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  );
                                  })}
                                </div>
                              )}
                                  </>
                                );
                              })()}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionHistorySection;
